import {ElasticValidation, ElasticValidator} from '../validator.factory';

const minLength = 3;

export class SourceResolverValidator implements ElasticValidator {
  validate(sourceName: string): ElasticValidation {
    if (sourceName === undefined || sourceName === null || sourceName === '') {
      return {isInvalid: false};
    }

    sourceName = sourceName.trim();
    if (sourceName === '') {
      return {isInvalid: true, errorMessage: `blanks are not allowed`};
    }

    const sourceNameValueTokens = sourceName.split(',');
    const sourceNameToken = sourceNameValueTokens[0];
    const radius = sourceNameValueTokens[1]?.trim();

    if (sourceNameToken.length < minLength) {
      return {isInvalid: true, errorMessage: `${sourceNameToken} has less than ${minLength} alphanumeric characters`};
    } else if (radius !== undefined && isNaN(Number(radius))) {
      return {isInvalid: true, errorMessage: `radius ${radius} is not a valid numeric format`};
    }

    return {isInvalid: false};
  }
}
